import { IAddress } from "@Interfaces/Api/user";

export function getselectedAddressForShipping(addresses: IAddress[]) {
  let selectedAddress = addresses.filter((address) => address.isDefault).pop();
  if (!selectedAddress) {
    selectedAddress = addresses[0];
  }
  return selectedAddress;
}
